import React, { useEffect, useState } from "react";
import "./scheduling.css";
import { supabase } from "../../Services/supabaseClient";
import { useCompany } from "../../context/CompanyContext";
import { SkeletonRow } from "../../components/scheduling/Skeleton";

function fmt(dt) {
  return new Date(dt).toLocaleString();
}

export default function Audit() {
  const { companyId } = useCompany();
  const [rows, setRows] = useState([]);
  const [busy, setBusy] = useState(true);
  const [err, setErr] = useState("");

  async function load() {
    if (!companyId) return;
    setBusy(true);
    setErr("");
    try {
      const { data, error } = await supabase
        .from("space_audit_log")
        .select("*")
        .eq("company_id", companyId)
        .order("created_at", { ascending: false })
        .limit(200);

      if (error) throw error;
      setRows(data || []);
    } catch (e) {
      setErr(e?.message || "Failed to load audit logs");
    } finally {
      setBusy(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyId]);

  return (
    <div className="sched-card">
      <div className="sched-card-head">
        <div>
          <h3 className="sched-h3">Audit Log</h3>
          <p className="sched-muted">
            All actions are recorded with before/after state. (Latest 200)
          </p>
        </div>
      </div>

      {busy ? (
        <>
          <SkeletonRow cols={5} />
          <SkeletonRow cols={5} />
        </>
      ) : err ? (
        <div className="sched-error">{err}</div>
      ) : rows.length === 0 ? (
        <div className="sched-empty">
          <div className="sched-empty-title">No audit records yet</div>
          <div className="sched-muted">
            Audit records appear after space/booking actions.
          </div>
        </div>
      ) : (
        <div className="sched-table">
          <div className="sched-thead">
            <span>Time</span>
            <span>Action</span>
            <span>Entity</span>
            <span>Actor</span>
            <span>Reason</span>
          </div>

          {rows.map((r) => (
            <div key={r.id} className="sched-tr">
              <span>{fmt(r.created_at)}</span>
              <span className="ellipsis">{r.action}</span>
              <span className="ellipsis">
                {r.entity_type}:{String(r.entity_id).slice(0, 8)}…
              </span>
              <span className="ellipsis">
                {String(r.actor_user_id).slice(0, 8)}…
              </span>
              <span className="ellipsis">{r.reason || "—"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
